import * as React from 'react';

// Markdown file-type glyph (document with "M↓"). Multi-color by design; size via CSS width/height.
export default () => (
  <svg width="46" height="64" viewBox="0 0 46 64" fill="none">
    <path
      d="M4 0.5H30.7188C31.7108 0.500057 32.6566 0.920827 33.3203 1.6582L44.6016 14.1934C45.18 14.836 45.5 15.6705 45.5 16.5352V60C45.5 61.933 43.933 63.5 42 63.5H4C2.067 63.5 0.5 61.933 0.5 60V4C0.5 2.12727 1.97083 0.598421 3.82031 0.504883L4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H30.7188C31.7108 0.500057 32.6566 0.920827 33.3203 1.6582L44.6016 14.1934C45.18 14.836 45.5 15.6705 45.5 16.5352V60C45.5 61.933 43.933 63.5 42 63.5H4C2.067 63.5 0.5 61.933 0.5 60V4C0.5 2.12727 1.97083 0.598421 3.82031 0.504883L4 0.5Z"
      fill="#F0F2F5"
      fillOpacity="0.2"
    />
    <path
      d="M4 0.5H30.7188C31.7108 0.500057 32.6566 0.920827 33.3203 1.6582L44.6016 14.1934C45.18 14.836 45.5 15.6705 45.5 16.5352V60C45.5 61.933 43.933 63.5 42 63.5H4C2.067 63.5 0.5 61.933 0.5 60V4C0.5 2.12727 1.97083 0.598421 3.82031 0.504883L4 0.5Z"
      stroke="#B5BFD2"
    />
    <g clipPath="url(#markdown_clip)">
      <path
        d="M37.5456 53H8.45435C7.80342 53 6.96028 52.962 6.5 52.5C6.03972 52.038 6 51.19 6 50.5367V34.4633C6 33.81 6.03972 32.962 6.5 32.5C6.96028 32.038 7.80342 32 8.45435 32H37.5456C38.1966 32 39.0397 32.038 39.5 32.5C39.9603 32.962 40 33.81 40 34.4633V50.5388C39.9994 51.1918 39.9602 52.0385 39.5 52.5C39.0398 52.9615 38.1962 53 37.5456 53ZM7.87509 33C7.76735 32.9998 7.66063 33.021 7.56105 33.0623C7.46147 33.1036 7.371 33.1642 7.29481 33.2406C7.21862 33.3171 7.15823 33.4079 7.11708 33.5079C7.07594 33.6078 7.05486 33.7149 7.05505 33.823L7.05422 51.0447C7.05441 51.1526 7.07577 51.2594 7.11708 51.359C7.1584 51.4586 7.21886 51.5491 7.295 51.6252C7.37115 51.7014 7.4615 51.7617 7.56089 51.8028C7.66028 51.844 7.76676 51.865 7.87426 51.8648H38.1235C38.3402 51.8646 38.5481 51.7782 38.7014 51.6244C38.8547 51.4707 38.941 51.2622 38.9414 51.0447V33.823C38.9416 33.7151 38.9206 33.6082 38.8796 33.5084C38.8386 33.4086 38.7783 33.3178 38.7024 33.2414C38.6264 33.165 38.5362 33.1043 38.4369 33.0629C38.3376 33.0215 38.2311 33.0001 38.1235 33H7.87509Z"
        fill="#B5BFD2"
      />
      <path
        d="M10.9037 48.0777V36.9202H14.173L17.4423 41.0216L20.7117 36.9216H23.981V48.0791H20.7117V41.6795L17.4423 45.781L14.173 41.6795V48.0777H10.9037ZM31.3369 48.0777L26.4325 42.6641H29.7018V36.9216H32.9712V42.6641H36.2405L31.3369 48.0777Z"
        fill="#B5BFD2"
      />
    </g>
    <defs>
      <clipPath id="markdown_clip">
        <rect width="34" height="21" fill="white" transform="translate(6 32)" />
      </clipPath>
    </defs>
  </svg>
);
